/**
 *
 * Custom function
 *
 */ 

(function($) {

	/*
	 *  Funzione per il toggle del menu delle lingue
	 */
	function toggleLang() {
		
		$('.current-lang').click(function(e) {
			e.preventDefault();
			$('nav.language').toggle();
		});

	}

	/*
	 * Funzione per gestire lo scroll sul menu mobile
	 */
	
	function scrollMobile() {
		var header = $('#js-header'),
			menu = $('#js-fixed-menu');

		if ( $('body').is('.is-mobile') ) {
			var headerH = header.outerHeight(),
				menuH = menu.innerHeight(),
				scrollValue = headerH - menuH;
			
			$(window).scroll(function() {
				scrolltop = $(window).scrollTop();

				if (scrolltop >= scrollValue) {
					menu.addClass("scroll");
				} else {
					menu.removeClass("scroll");
				}
			});
		}
	}

	/*
	 * Funzione per utilizzare MixItUp da select
	 */

	function filterElements() {
		
		var filterSelect = '.select-offers',
			container = '.mix-filter-support';

		if ( $(container).length ) {
			var mixer = mixitup(container);

			$(filterSelect).on('change', function(){
				mixer.filter(this.value);
			});
		}

	}

	$.edt_edtCountdown = function(){
		return false;
	}

	$.edt_translateCountdown = function( langCountdown ) {
		return false;
	}

	/*
    *	Attraverso il Google Loader carico il modulo mappa
    */
    $.edt_loadGmap = function() {
		if ( $('body').hasClass('sezioni-template-template-mappa') ) {
			console.log('lo messo dentro');
			$.getScript('https://www.google.com/jsapi', function() {
				if(url.key) {
					var map_params = 'language=' + url.lingua + '&key=' + url.key;
				}
				else {
					var map_params = 'language=' + url.lingua;
				}
				google.load('maps', '3', {
					other_params: map_params,
					callback: function() {
						$.edt_initializeGmap();
					}
				});
			});
		}
	}
	
	function animateBooking() {
		var referrer = $('.header-slideshow');
		if (!$("body").is('.mobile')) {

			if ($('.header-slideshow').length && $('body').is('.home')) {
				$(window).scroll(function () {
					var scrolltop = $(window).scrollTop();
					var pos = referrer.position().top + referrer.offset().top + referrer.outerHeight(true);

					if (scrolltop >= pos) {
						$('#booking-container').addClass("bottom");
					} else {
						$('#booking-container').removeClass("bottom");
					}
				});
			}
			else {
				$('#booking-container').addClass("bottom");
			}

		}
	}

	$(document).ready(function() {

		toggleLang();
		scrollMobile();

		if ( $('body').is('.is-mobile') ) {
			filterElements();
		}

		// Taglio descrizione feedback
		$('#feedback .item .description').collapser({
			mode: 'chars',
			truncate: 340,
			showText: '[ + ]',
			hideText: '[ - ]',
			controlBtn: 'opener',
		});

		$('.feedback-offer .item .description').collapser({
			mode: 'chars',
			truncate: 340,
			showText: '[ + ]',
			hideText: '[ - ]',
			controlBtn: 'opener',
		});
		
	});


	$(window).load(function() {

		// $.edt_loadGmap();
		animateBooking();

		// Aggiustamento per testata fissa
		if ( $('body').is('.is-mobile') ) {
			$('#page').css( 'margin-top', $('.menu-fixed-scroll').outerHeight() );
		} else {
			$('#page').css( 'margin-top', $('#js-header').outerHeight() );
		}

		// Altezze uguali per blocchi descrittivi
		$('#offerts .item').equalHeights();
		$('#offerts .item .data').equalHeights();
		$('.offert-list .item').equalHeights();
		$('.offert-list .item .data').equalHeights();
		$('.equal-height').equalHeights();

		// Aggiustamento margini contenuto fluido
		var pad = ( $(window).width() > 1920 ) ? 240 : Math.floor( ( $(window).width() - $('.container').innerWidth() ) / 2 ) + 15;
		$('.content-area.front main').css( 'padding-left', pad );
		$('.content-area.front #feedback').css( 'padding-right', pad );
		$('.content-area.front #feedback .owl-item').css( 'padding-right', pad );

	});

	$(window).resize(function() {


	});

})(jQuery);
